import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-node",
  "use": "icon-node-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-node\"><path d=\"M512 624a112 112 0 100-224 112 112 0 000 224z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol